var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskStatusPacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D9F7BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.575 8.93612L12.45 6.67815C12.3121 6.60228 12.1574 6.5625 12 6.5625C11.8426 6.5625 11.6879 6.60228 11.55 6.67815L7.425 8.93612C7.2774 9.01688 7.15425 9.13588 7.06848 9.28062C6.9827 9.42537 6.93746 9.59053 6.9375 9.75878V14.241C6.93746 14.4092 6.9827 14.5744 7.06848 14.7191C7.15425 14.8639 7.2774 14.9829 7.425 15.0636L11.55 17.3216C11.6878 17.3975 11.8426 17.4374 12 17.4374C12.1574 17.4374 12.3122 17.3975 12.45 17.3216L16.575 15.0636C16.7226 14.9829 16.8457 14.8639 16.9315 14.7191C17.0173 14.5744 17.0625 14.4092 17.0625 14.241V9.75878C17.0625 9.59053 17.0173 9.42537 16.9315 9.28062C16.8457 9.13588 16.7226 9.01688 16.575 8.93612ZM12 7.71409L15.375 9.56237L14.3705 10.1122L10.9955 8.2644L12 7.71409ZM12 11.4092L8.625 9.56237L9.82312 8.90612L13.1981 10.7535L12 11.4092ZM8.0625 10.5369L11.4375 12.3838V15.9777L8.0625 14.1299V10.5369ZM12.5625 15.9777V12.3838L13.6875 11.7683V13.1249C13.6875 13.2741 13.7468 13.4171 13.8523 13.5226C13.9577 13.6281 14.1008 13.6874 14.25 13.6874C14.3992 13.6874 14.5423 13.6281 14.6477 13.5226C14.7532 13.4171 14.8125 13.2741 14.8125 13.1249V11.1524L15.9375 10.5369V14.1299L12.5625 15.9777Z",
    fill: "#237804"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskStatusPacked);
export default __webpack_public_path__ + "static/media/task-status-packed.d683978e.svg";
export { ForwardRef as ReactComponent };